import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';

const Diamond = ({ position = [0, 1, 0], color = '#00ffff' }) => {
  const ref = useRef();
  useFrame((state, delta) => {
    if (!ref.current) return;
    ref.current.rotation.y += delta * 0.6;
    // Local bobbing around the group's origin (do not add position[1] again)
    ref.current.position.y = Math.sin(state.clock.getElapsedTime() * 2) * 0.1;
  });
  return (
    <group position={[position[0], position[1], position[2]]}>
      <mesh ref={ref} castShadow receiveShadow>
        <icosahedronGeometry args={[0.25, 0]} />
        <meshStandardMaterial color={color} emissive={color} emissiveIntensity={2.0} metalness={0.4} roughness={0.2} />
      </mesh>
      <pointLight color={color} intensity={1.5} distance={5} />
    </group>
  );
};

export default Diamond;
